import React from 'react';
import StylesPaymentsAreaAdmin from './PaymentsPageAdmin.styles';
import PageTitle from '../../components/PageTitle';
import BalanceTableAreaAdmin from '../../components/BalanceTableAreaAdmin/BalanceTableAreaAdmin';

const PaymentsPageAdmin = () => {
  return (
    <StylesPaymentsAreaAdmin>
      <PageTitle title="Payments" />
      <BalanceTableAreaAdmin />
    </StylesPaymentsAreaAdmin>
  );
};

export default PaymentsPageAdmin;
